import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TRANSLOCO_SCOPE, TranslocoModule } from '@jsverse/transloco';

@Component({
  selector: 'boels-product-new',
  templateUrl: './product-new.component.html',
  styleUrls: ['./product-new.component.scss'],
  imports: [TranslocoModule],
  providers: [
    {
      provide: TRANSLOCO_SCOPE,
      useValue: ['productDetails'],
    },
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductNewComponent {}
